import {
  GET_SUBSTITUE_BIKES_START,
  GET_SUBSTITUE_BIKES_SUCCESS,
  GET_SUBSTITUE_BIKES_ERROR,
  GET_UPDATE_SUBSTITUE_BIKES,
  GET_UPDATE_SUBSTITUE_BIKES_SUCCESS,
  GET_UPDATE_SUBSTITUE_BIKES_ERROR,
  CLEAR_PREVIOUS_DATA,
} from "Constant";

const initialState = {
  loading: false,
  data: [],
  updateData: null,
};

export default function substituteReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case GET_SUBSTITUE_BIKES_START:
      return {
        ...state,
        loading: true,
      };
    case GET_SUBSTITUE_BIKES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case GET_SUBSTITUE_BIKES_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case GET_UPDATE_SUBSTITUE_BIKES:
      return {
        ...state,
        loading: false,
      };
    case GET_UPDATE_SUBSTITUE_BIKES_SUCCESS:
      return {
        ...state,
        loading: false,
        updateData: action.payload,
      };
    case GET_UPDATE_SUBSTITUE_BIKES_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case CLEAR_PREVIOUS_DATA:
      return {
        loading: false,
        data: [],
        updateData: null,
      };
    default:
      return state;
  }
}
